import React, { Component } from 'react'
import Personal from './Personal'
import Orgainstaion from './Orgainstaion'
import { strVal } from '../../../../../modules/Utils'
import Members from '../../../../../api/Members'
import { withRouter } from 'react-router-dom'
import omitEmpty from 'omit-empty'

class PersonalCont extends Component {
  constructor(props) {
    super(props)
    this.api = new Members()
    this.key = props.member._key
    this.state = {
      error: { message: '', type: '', key: '' },
      counter: 0,
      loading: false,
      submitting: false,
      member: props.member,
    }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    const response = await this.api.get(this.key)
    const member = await response.json()
    this.setState({ member, loading: false })
  }

  handleSubmit = async (user) => {
    try {
      this.setState({ submitting: true })
      user = omitEmpty(user)
      const response = await this.api.update(user)
      let updatedMember = await response.json()
      this.setState({ submitting: false, member: updatedMember })
      this.props.handleUpdated()
      return updatedMember
    } catch (error) {
      this.setState({
        error: {
          message: strVal(error, 'errorMessage'),
          type: 'login',
          key: this.state.counter++,
        },
        submitting: false,
      })
    }
  }

  render() {
    const { formItemLayout, type } = this.props
    return this.state.member.kind === 'individual' ? (
      <Personal
        loading={this.state.loading}
        member={this.state.member}
        formItemLayout={formItemLayout}
        error={this.state.error}
        handleSubmit={this.handleSubmit}
        submitting={this.state.submitting}
      />
    ) : (
      <Orgainstaion
        loading={this.state.loading}
        member={this.state.member}
        formItemLayout={formItemLayout}
        error={this.state.error}
        handleSubmit={this.handleSubmit}
        submitting={this.state.submitting}
      />
    )
  }
}

export default withRouter(PersonalCont)
